const React = require("react");
const PropTypes = require("prop-types");
const InstagramFeed = require("../../social/instagram-feed");

function InstagramFeedSection({ data }) {
  return React.createElement(InstagramFeed, {
    ctaHref: data.ctaUrl,
    ctaLabel: data.ctaText,
    heading: data.heading,
    items: data.items,
    limit: data.limit,
  });
}

InstagramFeedSection.propTypes = {
  data: PropTypes.shape({
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
    heading: PropTypes.string,
    items: PropTypes.array,
    limit: PropTypes.number,
  }).isRequired,
};

module.exports = InstagramFeedSection;
